import { Field, Form } from "react-final-form";
import { FormContainer, Input } from "../../components/inputs";
import { useLocation, useNavigate } from "react-router-dom";

import { Button } from "../../components/button";
import { Text } from "../../components/typography";
import styled from "styled-components";

export const CategoryForm = (props) => {
  const { onFormSubmit, initialValues } = props;

  const navigate = useNavigate();
  const location = useLocation();

  const onCloseandReset = (reset) => {
    reset();

    const direction = location.pathname.split("/").includes("edit")
      ? navigate(-1, { replace: true })
      : navigate("/", { replace: true });
    return direction;
  };

  return (
    <Form onSubmit={onFormSubmit} initialValues={initialValues}>
      {({ handleSubmit, pristine, submitting, invalid, form: { reset } }) => (
        <form onSubmit={handleSubmit}>
          <FormContainer>
            <Field
              name="name"
              type="text"
              component={Input}
              label="Category Title"
              placeholder="Enter category name"
            />
          </FormContainer>
          <ButtonFlex>
            <Text scale="small" onClick={() => onCloseandReset(reset)}>
              Cancel
            </Text>
            <Button
              type="submit"
              disabled={submitting || pristine || invalid}
              text={submitting ? "Saving..." : "Save"}
            />
          </ButtonFlex>
        </form>
      )}
    </Form>
  );
};
const ButtonFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  a:link,
  p,
  button {
    margin: 0;
    cursor: pointer;
  }
`;
